import React, { FC } from 'react'

import { InputField, InputFieldProps } from 'common/components/Form'

export const DamageNumberField: FC<InputFieldProps> = props => {
  const mask = `dddd . dd . dd . ddddd . d`
  const formatChars = {
    d: '[0-9]',
  }

  return (
    <InputField
      {...props}
      maskOptions={{
        mask,
        formatChars,
        maskChar: '_',
      }}
    />
  )
}
